module.exports = {"name":"Online Verification","steps":[{"key":"netverify","state":"verification.netverify.perform","heading":"Perform Online Verification","label":"Online Verification","returnTo":"verification","keepStateOnPrev":true}]}


//////////////////
// WEBPACK FOOTER
// ./src/holding/modules/app/modules/holding/modules/dashboard/modules/verification/controllers/netverify/flow.json
// module id = 1030
// module chunks = 0